document.addEventListener('DOMContentLoaded', function () {
	const blocks = document.querySelectorAll('.animated-image');

	if (!blocks.length || !window.IntersectionObserver) {
		blocks.forEach((block) => block.classList.add('is-visible'));
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			});
		},
		{ threshold: 0.15 }
	);

	blocks.forEach((block) => observer.observe(block));
});
